module.exports = __webpack_public_path__ + "media/ui-click.3601aa01.mp3";